"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../_Core/Icons");
var Buttons_1 = require("../../Buttons/");
var BaseModal_1 = require("../../Internal/BaseModal");
var Localization_1 = require("../../Localization/");
var CameraPhoto_1 = require("./CameraPhoto");
var Cropper_1 = require("./Cropper");
var NavButtons_1 = require("./NavButtons");
var PhotoUpload_1 = require("./PhotoUpload");
var UploadAvatar_styles_1 = require("./UploadAvatar.styles");
exports.default = (function (_a) {
    var OnCancel = _a.OnCancel, OnComplete = _a.OnComplete, AcceptedFileTypes = _a.AcceptedFileTypes, MaximumFileSize = _a.MaximumFileSize, _b = _a.EncoderOptions, EncoderOptions = _b === void 0 ? 0.92 : _b, _c = _a.EncoderImageType, EncoderImageType = _c === void 0 ? "image/jpeg" : _c;
    var _d = React.useState({ Screen: "UploadPhoto" }), state = _d[0], setState = _d[1];
    var cropPhotoRef = React.createRef();
    var currentEditingFile;
    var handleFileFromInputElement = function (dataUrl, originalFile) {
        currentEditingFile = originalFile;
        setState({ Screen: "CropImage", DataUrl: dataUrl });
    };
    var handlePhotoTaken = function (dataUrl, originalFile) {
        currentEditingFile = originalFile;
        setState({ Screen: "CropImage", DataUrl: dataUrl });
    };
    var buildHeight = function () {
        switch (state.Screen) {
            case "TakePhoto": return "550px";
            case "UploadPhoto": return "340px";
            case "CropImage": return "580px";
        }
    };
    var buildImageFromBase64State = function () {
        var image = new Image();
        image.src = state.DataUrl;
        return image;
    };
    var handleCropClick = function () {
        OnComplete(cropPhotoRef.current.getCroppedCanvas(), currentEditingFile);
    };
    return (React.createElement(BaseModal_1.BaseModal, { Header: Localization_1.strings.UploadAvatar_Label_HeaderCaption, Width: "500px", Height: buildHeight(), OnCloseRequest: OnCancel },
        (state.Screen === "UploadPhoto" || state.Screen === "TakePhoto") &&
            React.createElement(NavButtons_1.default, { CurrentType: state.Screen, OnButtonClick: function (type) { return setState({ Screen: type }); } }),
        state.Screen === "UploadPhoto" &&
            React.createElement(UploadAvatar_styles_1.ScreensWrapper, null,
                React.createElement(PhotoUpload_1.default, { OnFileHasBeenAccepted: handleFileFromInputElement, AcceptedFileTypes: AcceptedFileTypes, MaximumFileSize: MaximumFileSize })),
        state.Screen === "TakePhoto" &&
            React.createElement(UploadAvatar_styles_1.ScreensWrapper, null,
                React.createElement(CameraPhoto_1.default, { OnTakePhoto: handlePhotoTaken, EncoderOptions: EncoderOptions, EncoderImageType: EncoderImageType })),
        state.Screen === "CropImage" &&
            React.createElement(React.Fragment, null,
                React.createElement(UploadAvatar_styles_1.CropperWrapper, null,
                    React.createElement(Cropper_1.default, { ref: cropPhotoRef, CropImage: buildImageFromBase64State(), EncoderOptions: EncoderOptions, EncoderImageType: EncoderImageType })),
                React.createElement(UploadAvatar_styles_1.CropperButtons, null,
                    React.createElement(Buttons_1.PrimaryButton, { Icon: Icons_1.Icons.Tick, Caption: Localization_1.strings.UploadAvatar_Action_AcceptButton, OnClick: handleCropClick })))));
});
